/**
 * Vista: Detalle/Nuevo Carnet de Servicio
 * Formato: AMX-PVTA-FR-01_R6 (Carnet de Servicios Tractores No Certificados)
 */

import posventaService from '../services/posventa.service.js';
import tractorService from '../services/tractor.service.js';
import personaService from '../services/persona.service.js';
import recepcionService from '../services/recepcion.service.js';
import api from '../services/api.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';

import { hoyLocal } from '../utils/fechas.js';
// 7 intervalos de servicio estándar
const INTERVALOS = [
  { horas: 50, nombre: 'SERVICIO TÉCNICO 50 HORAS' },
  { horas: 350, nombre: 'SERVICIO TÉCNICO 350 HORAS' },
  { horas: 650, nombre: 'SERVICIO TÉCNICO 650 HORAS' },
  { horas: 950, nombre: 'SERVICIO TÉCNICO 950 HORAS' },
  { horas: 1250, nombre: 'SERVICIO TÉCNICO 1250 HORAS' },
  { horas: 1550, nombre: 'SERVICIO TÉCNICO 1550 HORAS' },
  { horas: 1850, nombre: 'SERVICIO TÉCNICO 1850 HORAS' }
];

export default {
  data: {
    carnet: null,
    tractor: null,
    isNew: false,
    hasUnsavedChanges: false,
    distribuidores: []
  },

  async render(params) {
    this.data.isNew = !params.id || params.id === 'nuevo';

    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 0.5rem;">
          <h2 class="card-title">${this.data.isNew ? 'Nuevo Carnet de Servicio' : 'Carnet de Servicio'}</h2>
          <div id="headerButtons" style="display: flex; gap: 0.5rem;">
            <button class="btn btn-secondary" onclick="router.navigate('/posventa/carnets')">← Volver</button>
          </div>
        </div>
        <div id="carnetContent"><div style="text-align: center; padding: 2rem;">Cargando...</div></div>
      </div>
    `;
  },

  async afterRender(params) {
    window.carnetDetalleView = this;
    this.data.hasUnsavedChanges = false;
    this.injectStyles();

    // Cargar catálogos — distribuidores desde usuarios con persona (patrón unificado)
    try {
      const response = await api.get('/usuarios/responsables').catch(() => ({ data: [] }));
      const todos = Array.isArray(response.data) ? response.data : (response.data?.usuarios || []);
      this.data.distribuidores = todos
        .filter(u => u.persona_id)
        .map(u => ({ id: u.persona_id, nombre_completo: u.persona_nombre_completo || u.nombre_completo }));
    } catch (e) { /* catálogo opcional */ }

    if (this.data.isNew) {
      this.renderFormularioNuevo();
    } else {
      await this.cargarCarnet(params.id);
    }
  },

  injectStyles() {
    if (document.getElementById('carnet-detalle-styles')) return;
    const style = document.createElement('style');
    style.id = 'carnet-detalle-styles';
    style.textContent = `
      .carnet-tabs { display: flex; padding: 0; background: transparent; border-bottom: 2px solid #e5e7eb; margin-bottom: 1rem; }
      .carnet-tab { flex: 1; padding: 0.6rem 1rem; border: none; border-bottom: 3px solid transparent; margin-bottom: -2px; background: transparent; color: #6b7280; font-size: 0.875rem; font-weight: 500; cursor: pointer; transition: all 0.2s ease; text-align: center; }
      .carnet-tab:hover:not(.active) { color: #374151; border-bottom-color: #d1d5db; }
      .carnet-tab.active { color: var(--primary); font-weight: 600; border-bottom-color: var(--primary); }
      .carnet-panel { background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; }
      .servicio-bloque { border: 1px solid var(--border-color); border-radius: 8px; padding: 1rem; margin-bottom: 0.75rem; background: var(--bg-primary); }
      .servicio-bloque-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.75rem; }
      .servicio-bloque-title { font-weight: 700; color: var(--primary); font-size: 0.9rem; }
      .servicio-badge-done { background: var(--success); color: white; padding: 0.2rem 0.6rem; border-radius: 4px; font-size: 0.75rem; font-weight: 600; }
      .servicio-badge-pending { background: #e5e7eb; color: #6b7280; padding: 0.2rem 0.6rem; border-radius: 4px; font-size: 0.75rem; font-weight: 600; }
      .servicio-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem; }
      @media (max-width: 768px) {
        .servicio-grid { grid-template-columns: 1fr; }
        .identificacion-grid { grid-template-columns: 1fr !important; }
      }
      .sello-container { border: 2px dashed var(--border-color); border-radius: 8px; min-height: 80px; display: flex; align-items: center; justify-content: center; color: var(--text-secondary); font-size: 0.8rem; position: relative; overflow: hidden; }
      .sello-container img { max-width: 100%; max-height: 80px; object-fit: contain; }
      .servicio-bloque dd { word-break: break-word; overflow-wrap: break-word; }
    `;
    document.head.appendChild(style);
  },

  // ======================== CARGAR ========================

  async cargarCarnet(id) {
    try {
      const response = await posventaService.obtenerCarnet(id);
      this.data.carnet = response.data || response;
      this.data.hasUnsavedChanges = false;
      this.signaturePad_cliente = null;
      this.renderCarnetExistente();
    } catch (error) {
      toast.error('Error al cargar carnet');
      router.navigate('/posventa/carnets');
    }
  },

  // ======================== FORMULARIO NUEVO ========================

  renderFormularioNuevo() {
    const container = document.getElementById('carnetContent');

    container.innerHTML = `
      <!-- Buscar Tractor -->
      <div style="background: white; border: 1px solid var(--gray-200); padding: 1.25rem 1.5rem; border-radius: 8px; margin-bottom: 1rem;">
        <h4 style="margin: 0 0 0.25rem; font-size: 1rem; font-weight: 600;">Buscar por número de serie</h4>
        <p style="margin: 0 0 1rem; color: var(--text-muted); font-size: 0.85rem;">Ingrese el número de serie del tractor para cargar sus datos automáticamente</p>
        <div style="display: flex; gap: 0.75rem; align-items: center;">
          <input
            type="text"
            id="numSerieBuscar"
            class="form-input"
            style="flex: 1;"
            placeholder="Ej: TE354-2026-0127"
          />
          <button type="button" class="btn btn-primary" onclick="window.carnetDetalleView.buscarTractor()">
            Buscar
          </button>
        </div>
        <div id="tractorResult" style="margin-top: 1rem;"></div>
      </div>

      <div id="formularioPrincipal" style="display: none;">
        <!-- Identificación de Equipo -->
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
          <h3 style="margin-bottom: 1rem;">Identificación de Equipo</h3>
          <input type="hidden" id="numSerie" />
          <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem;" class="identificacion-grid">
            <div class="form-group">
              <label class="form-label">Modelo</label>
              <input type="text" id="infoModelo" class="form-input" readonly />
            </div>
            <div class="form-group">
              <label class="form-label">Num. de Serie de Motor</label>
              <input type="text" id="infoSerieMotor" class="form-input" readonly />
            </div>
            <div class="form-group">
              <label class="form-label">Modelo de Motor</label>
              <input type="text" id="inputModeloMotor" class="form-input" style="text-transform: uppercase;" placeholder="Ej: 4DW81-23D" />
            </div>
            <div class="form-group">
              <label class="form-label">Fecha de Compra</label>
              <input type="date" id="inputFechaEntrega" class="form-input" value="${hoyLocal()}" />
            </div>
            <div class="form-group">
              <label class="form-label">Cliente (Propietario)</label>
              <input type="text" id="inputPropietario" class="form-input" readonly />
            </div>
            <div class="form-group">
              <label class="form-label">Distribuidor *</label>
              <select id="inputDistribuidor" class="form-input">
                <option value="">Seleccione...</option>
                ${this.data.distribuidores.map(d => `<option value="${d.nombre_completo}">${d.nombre_completo}</option>`).join('')}
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Fabricante</label>
              <input type="text" class="form-input" readonly value="LOVOL International Heavy Industry Co., Ltd. (P.R.C.)" />
            </div>
          </div>
        </div>

        <!-- Tipo de Carnet (automático) -->
        <div id="tipoCarnetInfo" style="display: none; background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
        </div>

        <!-- Tabs -->
        <div class="carnet-tabs">
          <button class="carnet-tab active" onclick="window.carnetDetalleView.showTabNuevo('anotaciones')">Anotaciones</button>
          <button class="carnet-tab" onclick="window.carnetDetalleView.showTabNuevo('servicio')">Datos Servicio</button>
        </div>

        <!-- Tab: Anotaciones -->
        <div class="carnet-panel" id="panel-nuevo-anotaciones">
          <div class="form-group">
            <label class="form-label">Anotaciones generales</label>
            <textarea id="inputAnotaciones" class="form-input" rows="6" style="text-transform: uppercase;" placeholder="Anotaciones generales del carnet..."></textarea>
          </div>
        </div>

        <!-- Tab: Datos Servicio -->
        <div class="carnet-panel" id="panel-nuevo-servicio" style="display: none;">
          <p style="font-size: 0.8rem; color: var(--text-secondary); margin-bottom: 1rem;">
            Registre los servicios realizados (opcional)
          </p>
          <div id="serviciosBloqueNuevo">
            ${INTERVALOS.map(i => `
              <div class="servicio-bloque" id="bloque-nuevo-${i.horas}">
                <div class="servicio-bloque-header">
                  <span class="servicio-bloque-title">${i.nombre}</span>
                  <span class="servicio-badge-pending">PENDIENTE</span>
                </div>
                <button class="btn btn-sm btn-primary" onclick="window.carnetDetalleView.mostrarFormServicioNuevo(${i.horas})">
                  Registrar Servicio
                </button>
              </div>
            `).join('')}
          </div>
        </div>

        <!-- Botones -->
        <div style="display: flex; gap: 1rem; justify-content: flex-end; margin-top: 1rem;">
          <button type="button" class="btn btn-secondary" onclick="router.navigate('/posventa/carnets')">Cancelar</button>
          <button type="button" class="btn btn-success" onclick="window.carnetDetalleView.guardarNuevo()">Crear Carnet</button>
        </div>
      </div>
    `;

    // Buscar al presionar Enter; ocultar formulario si modifican el NS después de buscar
    const nsBuscar = document.getElementById('numSerieBuscar');
    if (nsBuscar) {
      nsBuscar.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.buscarTractor();
        }
      });
      nsBuscar.addEventListener('input', () => {
        if (this.data.tractor) {
          this.data.tractor = null;
          const fp = document.getElementById('formularioPrincipal');
          if (fp) fp.style.display = 'none';
          const result = document.getElementById('tractorResult');
          if (result) result.innerHTML = '';
        }
      });
    }
  },

  async buscarTractor() {
    const numSerie = document.getElementById('numSerieBuscar')?.value?.trim();
    if (!numSerie) { toast.error('Ingrese el número de serie'); return; }

    const resultDiv = document.getElementById('tractorResult');
    resultDiv.innerHTML = '<p>Buscando...</p>';

    try {
      const response = await tractorService.getByNumSerie(numSerie);
      const tractor = response.data || response;
      this.data.tractor = tractor;

      resultDiv.innerHTML = '';
      document.getElementById('formularioPrincipal').style.display = 'block';
      document.getElementById('numSerie').value = numSerie;
      document.getElementById('infoModelo').value = tractor.modelo || '';
      document.getElementById('infoSerieMotor').value = tractor.serie_motor || '';
      document.getElementById('inputPropietario').value = tractor.cliente?.nombre || '';
      if (tractor.fecha_entrega) {
        document.getElementById('inputFechaEntrega').value = tractor.fecha_entrega.split('T')[0];
      }

      // Tipo de carnet automático según certificación OCIMA
      const esCertificado = !!tractor.tiene_certificacion_ocima;
      this.data.tipoCarnet = esCertificado ? 'certificado' : 'no_certificado';
      const tipoInfo = document.getElementById('tipoCarnetInfo');
      tipoInfo.style.display = 'block';
      tipoInfo.innerHTML = esCertificado
        ? `<div style="display: flex; align-items: center; gap: 1rem; flex-wrap: wrap;">
            <div>
              <strong style="color: var(--success);">CERTIFICADO OCIMA</strong>
              <span style="color: var(--text-secondary); font-size: 0.85rem;"> — Formato AMX-PVTA-FR-05</span>
            </div>
            <div class="form-group" style="margin: 0; flex: 1; min-width: 200px;">
              <label class="form-label" style="margin-bottom: 0.25rem;">Folio de Certificación</label>
              <input type="text" id="inputFolioCertificado" class="form-input" placeholder="Ej: OCIMA-2026-001" />
            </div>
          </div>`
        : `<strong>No Certificado</strong>
          <span style="color: var(--text-secondary); font-size: 0.85rem;"> — Formato AMX-PVTA-FR-01</span>`;
    } catch (error) {
      resultDiv.innerHTML = `<div style="padding: 1rem; background: var(--danger); color: white; border-radius: 8px;">${error.message || 'Tractor no encontrado'}</div>`;
      document.getElementById('formularioPrincipal').style.display = 'none';
    }
  },

  async guardarNuevo() {
    const distribuidor = document.getElementById('inputDistribuidor')?.value;
    if (!distribuidor) { toast.error('Seleccione el distribuidor'); return; }

    const propietario = document.getElementById('inputPropietario')?.value?.trim() || null;
    const tipoCarnet = this.data.tipoCarnet || 'no_certificado';

    const data = {
      num_serie: document.getElementById('numSerie')?.value,
      modelo_motor: document.getElementById('inputModeloMotor')?.value?.trim()?.toUpperCase() || null,
      tipo_carnet: tipoCarnet,
      propietario: propietario || null,
      fecha_entrega: document.getElementById('inputFechaEntrega')?.value || null,
      distribuidor,
      folio_certificado: tipoCarnet === 'certificado' ? document.getElementById('inputFolioCertificado')?.value?.trim() || null : null,
      anotaciones: document.getElementById('inputAnotaciones')?.value?.trim()?.toUpperCase() || null
    };

    try {
      this._showProgress('Creando carnet...');
      const response = await posventaService.crearCarnet(data);
      const carnet = response.data || response;

      // Registrar servicios que tengan fecha llenada
      const serviciosPendientes = INTERVALOS.filter(i => document.getElementById(`srvNuevoFecha-${i.horas}`)?.value);
      if (serviciosPendientes.length > 0) {
        this._showProgress('Registrando servicios...');
        for (const intervalo of serviciosPendientes) {
          const fechaEl = document.getElementById(`srvNuevoFecha-${intervalo.horas}`);
          const obs = document.getElementById(`srvNuevoObs-${intervalo.horas}`)?.value?.trim()?.toUpperCase() || null;
          await posventaService.registrarServicio(carnet.id, {
            intervalo_horas: intervalo.horas,
            fecha_servicio: fechaEl.value,
            horas_operacion: intervalo.horas,
            observaciones: obs
          });
        }
      }

      this._hideProgress();
      toast.success('Carnet creado exitosamente');
      router.navigate(`/posventa/carnets/${carnet.id}`);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al crear carnet');
    }
  },

  // ======================== VISTA DETALLE/EDICIÓN ========================

  renderCarnetExistente() {
    const container = document.getElementById('carnetContent');
    const c = this.data.carnet;
    const servicios = c.servicios || [];
    const completada = !!c.completada;

    // Header buttons
    const headerButtons = document.getElementById('headerButtons');
    if (headerButtons) {
      headerButtons.innerHTML = `
        <button class="btn btn-secondary" onclick="router.navigate('/posventa/carnets')">← Volver</button>
        ${permisos.canPrint('servicios') ? `<button class="btn btn-primary" onclick="window.carnetDetalleView.imprimir()">🖨️ Imprimir</button>` : ''}
      `;
    }


    container.innerHTML = `
      <!-- Identificación de Equipo (siempre visible) -->
      <div class="carnet-panel" style="margin-bottom: 1.5rem;">
        <h3 style="margin-bottom: 1rem;">Identificación de Equipo</h3>
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem;" class="identificacion-grid">
          <div class="form-group">
            <label class="form-label">Num. de Serie</label>
            <input type="text" class="form-input" readonly value="${c.num_serie}" />
          </div>
          <div class="form-group">
            <label class="form-label">Marca</label>
            <input type="text" class="form-input" readonly value="${c.marca || 'LOVOL'}" />
          </div>
          <div class="form-group">
            <label class="form-label">Modelo</label>
            <input type="text" class="form-input" readonly value="${c.modelo || '-'}" />
          </div>
          <div class="form-group">
            <label class="form-label">Cliente</label>
            <input type="text" class="form-input" readonly value="${c.propietario || '-'}" />
          </div>
          <div class="form-group">
            <label class="form-label">Serie de Motor</label>
            <input type="text" class="form-input" readonly value="${c.serie_motor || '-'}" />
          </div>
          <div class="form-group">
            <label class="form-label">Distribuidor</label>
            <input type="text" class="form-input" readonly value="${c.distribuidor || '-'}" />
          </div>
          <div class="form-group">
            <label class="form-label">Modelo de Motor</label>
            ${!completada
              ? `<input type="text" id="editModeloMotor" class="form-input" style="text-transform: uppercase;" value="${c.modelo_motor || ''}" onchange="window.carnetDetalleView._showUnsaved()" />`
              : `<input type="text" class="form-input" readonly value="${c.modelo_motor || '-'}" />`}
          </div>
          <div class="form-group">
            <label class="form-label">Fecha de Compra</label>
            ${!completada
              ? `<input type="date" id="editFechaEntrega" class="form-input" value="${c.fecha_entrega ? c.fecha_entrega.split('T')[0] : ''}" onchange="window.carnetDetalleView._showUnsaved()" />`
              : `<input type="text" class="form-input" readonly value="${c.fecha_entrega ? new Date(c.fecha_entrega).toLocaleDateString('es-MX') : '-'}" />`}
          </div>
          ${c.tipo_carnet === 'certificado' ? `
          <div class="form-group">
            <label class="form-label">Certificado OCIMA</label>
            <input type="text" class="form-input" readonly value="${c.folio_certificado || 'Sí'}" />
          </div>
          ` : ''}
        </div>
      </div>

      <!-- Tabs -->
      <div class="carnet-tabs">
        <button class="carnet-tab active" onclick="window.carnetDetalleView.showTab('anotaciones')">Anotaciones</button>
        <button class="carnet-tab" onclick="window.carnetDetalleView.showTab('mantenimiento')">Mantenimiento</button>
        ${c.tipo_carnet === 'certificado' ? `<button class="carnet-tab" onclick="window.carnetDetalleView.showTab('firma')">Firma</button>` : ''}
      </div>

      <!-- Tab: Mantenimiento Técnico -->
      <div class="carnet-panel" id="panel-mantenimiento" style="display: none;">
        <h3 style="margin-bottom: 0.5rem; color: var(--primary);">MANTENIMIENTO TÉCNICO DE TRACTOR O COSECHADORA</h3>
        <p style="font-size: 0.8rem; color: var(--text-secondary); margin-bottom: 1rem;">
          Registre cada servicio técnico con fecha, observaciones y sello del taller
        </p>
        <div id="serviciosBloques">
          ${this._renderServiciosBloques(servicios)}
        </div>

      </div>

      <!-- Tab: Anotaciones -->
      <div class="carnet-panel" id="panel-anotaciones">
        <h3 style="margin-bottom: 1rem; color: var(--primary);">ANOTACIONES</h3>
        <div class="form-group">
          <textarea id="carnetAnotaciones" class="form-input" rows="8" style="text-transform: uppercase;"
            placeholder="Anotaciones generales del carnet..." ${completada ? 'readonly' : ''}>${c.anotaciones || ''}</textarea>
        </div>
      </div>

      ${c.tipo_carnet === 'certificado' ? `
      <!-- Tab: Firma Cliente -->
      <div class="carnet-panel" id="panel-firma" style="display: none;">
        <h3 style="margin-bottom: 1rem; color: var(--primary);">FIRMA DEL CLIENTE</h3>
        <div id="firmaClienteContainer" style="max-width: 400px; margin: 0 auto;">
        </div>
      </div>
      ` : ''}

      ${!completada ? `
      <!-- Indicador de cambios sin guardar -->
      <div id="unsavedIndicator" style="display: none; background: var(--warning); color: white; padding: 0.5rem 1rem; border-radius: 8px; margin-bottom: 1rem; text-align: center;">
        Hay cambios sin guardar
      </div>

      <!-- Botones -->
      <div style="display: flex; gap: 1rem; justify-content: flex-end; margin-top: 1rem;">
        <button type="button" class="btn btn-secondary" onclick="window.carnetDetalleView.volver()">Cancelar</button>
        <button type="button" class="btn btn-primary" onclick="window.carnetDetalleView.guardarCambios()">Guardar Cambios</button>
        ${permisos.can('servicios', 'cerrar') ? `<button type="button" class="btn btn-success" onclick="window.carnetDetalleView.completarCarnet()">Completar</button>` : ''}
      </div>
      ` : ''}
    `;

    // Detectar cambios sin guardar
    if (!completada) {
      document.querySelectorAll('#carnetContent input, #carnetContent textarea, #carnetContent select').forEach(el => {
        el.addEventListener('change', () => this._showUnsaved());
        el.addEventListener('input', () => this._showUnsaved());
      });
    }
  },

  _renderServiciosBloques(servicios) {
    return INTERVALOS.map((intervalo, index) => {
      const servicio = servicios.find(s => s.intervalo === intervalo.horas);
      const realizado = !!servicio && !!servicio.fecha_servicio;

      if (realizado) {
        return `
          <div class="servicio-bloque">
            <div class="servicio-bloque-header" style="cursor: pointer;" onclick="window.carnetDetalleView.toggleServicio(${intervalo.horas})">
              <div style="display: flex; align-items: center; gap: 0.5rem;">
                <span id="srv-btn-${intervalo.horas}" style="font-size: 0.75rem; transition: transform 0.2s;">▼</span>
                <span class="servicio-bloque-title">${intervalo.nombre}</span>
              </div>
              <span class="servicio-badge-done">REALIZADO</span>
            </div>
            <div id="srv-detail-${intervalo.horas}" style="display: none; margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px solid var(--border-color); font-size: 0.85rem;">
              <dl style="display: grid; grid-template-columns: 120px 1fr; gap: 0.25rem 1rem; margin: 0;">
                <dt style="font-weight: 600; color: var(--text-secondary);">Fecha</dt><dd style="margin: 0; word-break: break-word;">${new Date(servicio.fecha_servicio).toLocaleDateString('es-MX')}</dd>
                <dt style="font-weight: 600; color: var(--text-secondary);">Observaciones</dt><dd style="margin: 0; word-break: break-word;">${servicio.observaciones || '-'}</dd>
              </dl>
            </div>
          </div>
        `;
      } else {
        // Puede registrar si es el primero pendiente o si el anterior ya fue realizado
        const anteriores = INTERVALOS.slice(0, index);
        const todosAnterioresRealizados = anteriores.every(ant => servicios.find(s => s.intervalo === ant.horas && s.fecha_servicio));
        const puedeRegistrar = index === 0 || todosAnterioresRealizados;

        return `
          <div class="servicio-bloque" id="bloque-${intervalo.horas}" style="opacity: ${puedeRegistrar ? '1' : '0.5'};">
            <div class="servicio-bloque-header">
              <span class="servicio-bloque-title">${intervalo.nombre}</span>
              <span class="servicio-badge-pending">PENDIENTE</span>
            </div>
            ${puedeRegistrar ? `
              <button class="btn btn-sm btn-primary" onclick="window.carnetDetalleView.mostrarFormServicio(${intervalo.horas})">
                Registrar Servicio
              </button>
            ` : `<p style="font-size: 0.8rem; color: var(--text-secondary);">Complete el servicio anterior primero</p>`}
          </div>
        `;
      }
    }).join('');
  },

  // ======================== REGISTRAR SERVICIO ========================

  mostrarFormServicio(horasIntervalo) {
    const intervalo = INTERVALOS.find(i => i.horas === horasIntervalo);
    if (!intervalo) return;

    const bloque = document.getElementById(`bloque-${horasIntervalo}`);
    if (!bloque) return;

    bloque.style.borderColor = 'var(--primary)';
    bloque.style.borderWidth = '2px';
    bloque.innerHTML = `
      <div class="servicio-bloque-header">
        <span class="servicio-bloque-title">${intervalo.nombre}</span>
      </div>
      <div class="form-group">
        <label class="form-label">Fecha</label>
        <input type="date" id="srvFecha-${horasIntervalo}" class="form-input" value="${hoyLocal()}" onchange="window.carnetDetalleView._showUnsaved()" />
      </div>
      <div class="form-group">
        <label class="form-label">Observaciones</label>
        <textarea id="srvObs-${horasIntervalo}" class="form-input" rows="3" style="text-transform: uppercase;" placeholder="Observaciones del servicio..." oninput="window.carnetDetalleView._showUnsaved()"></textarea>
      </div>
      <div style="display: flex; justify-content: flex-end; margin-top: 0.5rem;">
        <button type="button" class="btn btn-sm btn-secondary" onclick="window.carnetDetalleView.cancelarServicio(${horasIntervalo})">Cancelar</button>
      </div>
    `;
    this._showUnsaved();
  },

  cancelarServicio(horasIntervalo) {
    // Recargar para restaurar el bloque
    this.cargarCarnet(this.data.carnet.id);
  },

  // ======================== EDITAR IDENTIFICACIÓN ========================

  editarIdentificacion() {
    const c = this.data.carnet;
    const container = document.getElementById('panel-identificacion');

    container.innerHTML = `
      <h3 style="margin-bottom: 1rem; color: var(--primary);">EDITAR IDENTIFICACIÓN</h3>
      <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1rem;" class="identificacion-grid">
        <div class="form-group">
          <label class="form-label">Cliente (Propietario)</label>
          <input type="text" id="editPropietario" class="form-input" style="text-transform: uppercase;" value="${c.propietario || ''}" />
        </div>
        <div class="form-group">
          <label class="form-label">Modelo de Motor</label>
          <input type="text" id="editModeloMotor" class="form-input" style="text-transform: uppercase;" value="${c.modelo_motor || ''}" />
        </div>
        <div class="form-group">
          <label class="form-label">Fecha de Compra</label>
          <input type="date" id="editFechaEntrega" class="form-input" value="${c.fecha_entrega ? c.fecha_entrega.split('T')[0] : ''}" />
        </div>
        <div class="form-group">
          <label class="form-label">Folio Certificado</label>
          <input type="text" id="editFolio" class="form-input" value="${c.folio_certificado || ''}" />
        </div>
      </div>
      <div style="display: flex; gap: 0.5rem; justify-content: flex-end; margin-top: 1rem;">
        <button class="btn btn-secondary" onclick="window.carnetDetalleView.cargarCarnet(${c.id})">Cancelar</button>
        <button class="btn btn-primary" onclick="window.carnetDetalleView.guardarIdentificacion()">Guardar</button>
      </div>
    `;
  },

  async guardarIdentificacion() {
    const c = this.data.carnet;
    const data = {
      propietario: document.getElementById('editPropietario')?.value?.trim()?.toUpperCase() || null,
      modelo_motor: document.getElementById('editModeloMotor')?.value?.trim()?.toUpperCase() || null,
      fecha_entrega: document.getElementById('editFechaEntrega')?.value || null,
      folio_certificado: document.getElementById('editFolio')?.value?.trim() || null
    };

    try {
      this._showProgress('Actualizando datos...');
      await posventaService.actualizarCarnet(c.id, data);
      this._hideProgress();
      toast.success('Datos actualizados');
      await this.cargarCarnet(c.id);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al actualizar');
    }
  },

  // ======================== GUARDAR CAMBIOS ========================

  async guardarCambios() {
    const c = this.data.carnet;

    // Recoger anotaciones
    const anotaciones = document.getElementById('carnetAnotaciones')?.value?.trim()?.toUpperCase() || null;

    // Recoger modelo motor y fecha si están editables
    const modeloMotorEl = document.getElementById('editModeloMotor');
    const fechaEntregaEl = document.getElementById('editFechaEntrega');

    const data = { anotaciones };
    if (modeloMotorEl) data.modelo_motor = modeloMotorEl.value?.trim()?.toUpperCase() || null;
    if (fechaEntregaEl) data.fecha_entrega = fechaEntregaEl.value || null;

    try {
      this._showProgress('Subiendo firmas...');

      // Subir firma del cliente si es certificado
      if (c.tipo_carnet === 'certificado') {
        const firmaUrls = await this.subirFirmaCliente();
        Object.assign(data, firmaUrls);
      }

      this._showProgress('Guardando cambios...');

      // Registrar servicios nuevos desde el DOM
      for (const intervalo of INTERVALOS) {
        const fechaEl = document.getElementById(`srvFecha-${intervalo.horas}`);
        if (fechaEl && fechaEl.value) {
          const obs = document.getElementById(`srvObs-${intervalo.horas}`)?.value?.trim()?.toUpperCase() || null;
          await posventaService.registrarServicio(c.id, {
            intervalo_horas: intervalo.horas,
            fecha_servicio: fechaEl.value,
            horas_operacion: intervalo.horas,
            observaciones: obs
          });
        }
      }

      // Actualizar datos del carnet
      await posventaService.actualizarCarnet(c.id, data);
      this._hideProgress();
      this._hideUnsaved();
      toast.success('Cambios guardados');
      await this.cargarCarnet(c.id);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al guardar cambios');
    }
  },

  _showUnsaved() {
    const el = document.getElementById('unsavedIndicator');
    if (el) el.style.display = 'block';
    this.data.hasUnsavedChanges = true;
  },

  _hideUnsaved() {
    const el = document.getElementById('unsavedIndicator');
    if (el) el.style.display = 'none';
    this.data.hasUnsavedChanges = false;
  },

  // ======================== FIRMA CLIENTE (certificado) ========================

  _renderFirmaCliente() {
    const container = document.getElementById('firmaClienteContainer');
    if (!container) return;

    const c = this.data.carnet;
    this.signaturePad_cliente = null;

    if (c.firma_cliente_url) {
      container.innerHTML = `
        <div class="firma-container-new" style="text-align: center;">
          <label class="form-label firma-label">Cliente</label>
          <p style="margin: 0 0 0.5rem; font-weight: 600;">${c.propietario || ''}</p>
          <img src="${c.firma_cliente_url}" style="width: 100%; max-height: 120px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />
          ${!c.completada ? `<a href="javascript:void(0)" class="firma-limpiar" onclick="window.carnetDetalleView.cambiarFirmaCliente()">Cambiar firma</a>` : ''}
        </div>
      `;
    } else if (!c.completada) {
      container.innerHTML = `
        <div class="firma-container-new" style="text-align: center;">
          <label class="form-label firma-label">Cliente</label>
          <p style="margin: 0 0 0.5rem; font-weight: 600;">${c.propietario || ''}</p>
          <div class="firma-box">
            <canvas id="firma-cliente" class="firma-canvas-new"></canvas>
            <span class="firma-placeholder" id="firma-placeholder-cliente">Toque para firmar</span>
          </div>
          <a href="javascript:void(0)" class="firma-limpiar" onclick="window.carnetDetalleView.limpiarFirmaCliente()">Limpiar</a>
        </div>
      `;
    } else {
      container.innerHTML = `
        <div style="text-align: center; padding: 2rem; color: var(--text-secondary);">Sin firma</div>
      `;
    }
  },

  async initFirmaCliente() {
    if (!window.SignaturePad) {
      try {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/signature_pad/4.1.7/signature_pad.umd.min.js';
          script.onload = resolve;
          script.onerror = () => reject(new Error('Error al cargar SignaturePad'));
          document.head.appendChild(script);
        });
      } catch (e) { toast.error('Error al cargar librería de firmas'); return; }
    }

    setTimeout(() => {
      const canvas = document.getElementById('firma-cliente');
      if (!canvas || this.signaturePad_cliente) return;

      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext('2d').scale(ratio, ratio);

      const pad = new SignaturePad(canvas, {
        backgroundColor: 'rgb(255, 255, 255)',
        penColor: 'rgb(0, 0, 0)'
      });
      this.signaturePad_cliente = pad;

      const placeholder = document.getElementById('firma-placeholder-cliente');
      if (placeholder) {
        canvas.addEventListener('pointerdown', () => placeholder.style.display = 'none');
      }

      // Activar "Hay cambios sin guardar" al terminar un trazo
      if (this._showUnsaved) pad.addEventListener('endStroke', () => this._showUnsaved());
    }, 100);
  },

  _showProgress(message) {
    let overlay = document.getElementById('progressOverlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'progressOverlay';
      overlay.style.cssText = 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.9); display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: 9999;';
      overlay.innerHTML = `
        <div class="spinner" style="margin-bottom: 1rem;"></div>
        <p id="progressMessage" style="font-size: 1rem; font-weight: 600; color: var(--gray-700);"></p>
      `;
      document.body.appendChild(overlay);
    }
    document.getElementById('progressMessage').textContent = message;
  },

  _hideProgress() {
    const overlay = document.getElementById('progressOverlay');
    if (overlay) overlay.remove();
  },

  limpiarFirmaCliente() {
    if (this.signaturePad_cliente) {
      this.signaturePad_cliente.clear();
      const placeholder = document.getElementById('firma-placeholder-cliente');
      if (placeholder) placeholder.style.display = 'block';
    }
  },

  cambiarFirmaCliente() {
    const c = this.data.carnet;
    if (c) c.firma_cliente_url = null;
    this.signaturePad_cliente = null;
    this._showUnsaved();
    this._renderFirmaCliente();
    this.initFirmaCliente();
  },

  async subirFirmaCliente() {
    const urls = {};
    const pad = this.signaturePad_cliente;
    if (pad && !pad.isEmpty()) {
      const dataURL = pad.toDataURL('image/png');
      const response = await fetch(dataURL);
      const blob = await response.blob();
      const numSerie = this.data.carnet?.num_serie;
      const url = await recepcionService.subirFirma(blob, `firma-cliente-carnet-${Date.now()}.png`, numSerie, 'carnet');
      urls.firma_cliente_url = url;
    }
    return urls;
  },

  volver() {
    if (this.data.hasUnsavedChanges) {
      if (!confirm('Hay cambios sin guardar. ¿Está seguro de salir?')) return;
    }
    router.navigate('/posventa/carnets');
  },

  // ======================== TABS ========================

  // Servicios pendientes en creación
  _serviciosNuevo: [],

  mostrarFormServicioNuevo(horas) {
    const intervalo = INTERVALOS.find(i => i.horas === horas);
    if (!intervalo) return;

    const bloque = document.getElementById(`bloque-nuevo-${horas}`);
    if (!bloque) return;

    bloque.style.borderColor = 'var(--primary)';
    bloque.style.borderWidth = '2px';
    bloque.innerHTML = `
      <div class="servicio-bloque-header">
        <span class="servicio-bloque-title">${intervalo.nombre}</span>
      </div>
      <div class="form-group">
        <label class="form-label">Fecha</label>
        <input type="date" id="srvNuevoFecha-${horas}" class="form-input" value="${hoyLocal()}" />
      </div>
      <div class="form-group">
        <label class="form-label">Observaciones</label>
        <textarea id="srvNuevoObs-${horas}" class="form-input" rows="2" style="text-transform: uppercase;" placeholder="Observaciones..."></textarea>
      </div>
      <div style="display: flex; justify-content: flex-end; margin-top: 0.5rem;">
        <button type="button" class="btn btn-sm btn-secondary" onclick="window.carnetDetalleView.cancelarServicioNuevo(${horas})">Cancelar</button>
      </div>
    `;
  },

  cancelarServicioNuevo(horas) {
    const intervalo = INTERVALOS.find(i => i.horas === horas);
    const bloque = document.getElementById(`bloque-nuevo-${horas}`);
    if (!bloque) return;

    bloque.style.borderColor = '';
    bloque.style.borderWidth = '';
    bloque.innerHTML = `
      <div class="servicio-bloque-header">
        <span class="servicio-bloque-title">${intervalo.nombre}</span>
        <span class="servicio-badge-pending">PENDIENTE</span>
      </div>
      <button class="btn btn-sm btn-primary" onclick="window.carnetDetalleView.mostrarFormServicioNuevo(${horas})">
        Registrar Servicio
      </button>
    `;
  },

  showTabNuevo(tab) {
    document.querySelectorAll('.carnet-tab').forEach(btn => btn.classList.remove('active'));
    document.querySelector(`.carnet-tab[onclick*="'${tab}'"]`)?.classList.add('active');
    const panels = { servicio: 'panel-nuevo-servicio', anotaciones: 'panel-nuevo-anotaciones' };
    Object.entries(panels).forEach(([key, id]) => {
      const el = document.getElementById(id);
      if (el) el.style.display = key === tab ? 'block' : 'none';
    });
  },

  showTab(tab) {
    document.querySelectorAll('.carnet-tab').forEach(btn => btn.classList.remove('active'));
    document.querySelector(`.carnet-tab[onclick*="'${tab}'"]`)?.classList.add('active');
    ['mantenimiento', 'anotaciones', 'firma'].forEach(t => {
      const el = document.getElementById(`panel-${t}`);
      if (el) el.style.display = t === tab ? 'block' : 'none';
    });

    if (tab === 'firma' && this.data.carnet && !this.data.carnet.completada) {
      this._renderFirmaCliente();
      this.initFirmaCliente();
    }
  },

  // ======================== TOGGLE SERVICIO ========================

  toggleServicio(horas) {
    const detail = document.getElementById(`srv-detail-${horas}`);
    const btn = document.getElementById(`srv-btn-${horas}`);
    if (detail) {
      const open = detail.style.display !== 'none';
      detail.style.display = open ? 'none' : 'block';
      if (btn) btn.style.transform = open ? '' : 'rotate(180deg)';
    }
  },

  // ======================== GUARDAR CAMPO INDIVIDUAL ========================

  async guardarCampo(campo, valor) {
    const c = this.data.carnet;
    try {
      await posventaService.actualizarCarnet(c.id, { [campo]: valor || null });
      this.data.carnet[campo] = valor || null;
      toast.success('Guardado');
    } catch (error) {
      toast.error(error.message || 'Error al guardar');
    }
  },

  // ======================== COMPLETAR / ELIMINAR ========================

  async completarCarnet() {
    const c = this.data.carnet;

    // 1. Validar cambios sin guardar
    if (this.data.hasUnsavedChanges) {
      toast.warning('Primero debes guardar los cambios antes de completar');
      return;
    }

    // 2. Validar 7 servicios completos
    const servicios = c.servicios || [];
    const faltantes = 7 - servicios.filter(s => s.fecha_servicio).length;

    if (faltantes > 0) {
      toast.error(`Faltan ${faltantes} servicio${faltantes > 1 ? 's' : ''} por registrar`);
      this.showTab('mantenimiento');
      return;
    }

    // 3. Validar firma del cliente si es certificado OCIMA
    if (c.tipo_carnet === 'certificado' && !c.firma_cliente_url) {
      toast.error('Se requiere la firma del cliente para completar el carnet certificado');
      this.showTab('firma');
      return;
    }

    if (!confirm('¿Está seguro de completar este carnet? Una vez completado no se podrá modificar.')) return;

    try {
      this._showProgress('Completando carnet...');
      await posventaService.actualizarCarnet(c.id, { completada: true });
      this._hideProgress();
      toast.success('Carnet completado');
      await this.cargarCarnet(c.id);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al completar carnet');
    }
  },

  async eliminarCarnet() {
    const c = this.data.carnet;
    if (!confirm('¿Está seguro de eliminar este carnet de servicio?')) return;

    try {
      this._showProgress('Eliminando carnet...');
      await posventaService.eliminarCarnet(c.id);
      this._hideProgress();
      toast.success('Carnet eliminado');
      router.navigate('/posventa/carnets');
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al eliminar carnet');
    }
  },

  // ======================== IMPRESIÓN ========================

  descargarPDF() {
    const c = this.data.carnet;
    if (!c) return;
    router.navigate(`/posventa/carnets/${c.id}/print`);
  },

  imprimir() {
    const c = this.data.carnet;
    if (!c) return;
    router.navigate(`/posventa/carnets/${c.id}/print`);
  },

  volver() {
    router.navigate('/posventa/carnets');
  }
};
